export enum StepKind {
    TRANSACTION = 'transaction',
    SIGNATURE = 'signature',
}

export enum StepItemStatus {
    COMPLETE = 'complete',
    INCOMPLETE = 'incomplete',
}

export enum SignatureKind {
    EIP191 = 'eip191',
    EIP712 = 'eip712',
}
